import React, { useState } from "react";
import blinkscribeapi from "../../../api/blinkscribeapi";
import { practiceFeatures } from "../../../config/practice";

/*
 * The visit note as a PDF to print (features.notePdf, 7825). OSA's staff print
 * an encounter from the chart's Summary > Notes card: its PDF icon opens the
 * BlinkScribe note PDF (rendered by the BlinkScribe server, GET {bs}/v1/
 * documents/PDF/{audiolink without extension}) in a new tab, and they print
 * it from the browser (OSA tabs/summary/Frame.jsx handlepdf). 7825's chart in
 * care has no Summary tab, so the same PDF opens from the note panel beside
 * the chart (LiveScribePanel), next to Edit -- same request, same document.
 */

// "abc123.wav" -> "abc123" (OSA: card.audiolink.split(".")[0]).
export function notePdfName(audiolink) {
  return audiolink ? String(audiolink).split(".")[0] : "";
}

export async function openNotePdf(audiolink) {
  const name = notePdfName(audiolink);
  if (!name) return;
  const response = await blinkscribeapi.get(`/v1/documents/PDF/${name}?_=${new Date().getTime()}`, {
    responseType: "blob",
  });
  const pdfBlob = new Blob([response], { type: "application/pdf" });
  window.open(URL.createObjectURL(pdfBlob), "_blank");
}

export function NotePdfButton({ audiolink }) {
  const [busy, setBusy] = useState(false);
  if (!practiceFeatures().notePdf || !notePdfName(audiolink)) return null;
  return (
    <button
      type="button"
      title="Open the note as a PDF to print"
      disabled={busy}
      onClick={async () => {
        setBusy(true);
        try {
          await openNotePdf(audiolink);
        } catch (error) {
          console.error("Error fetching the PDF:", error);
        } finally {
          setBusy(false);
        }
      }}
      style={{
        marginLeft: "6px", fontSize: "10px", fontWeight: 600,
        color: "#1D2951", background: "none", border: "1px solid #1D2951",
        borderRadius: "4px", padding: "2px 8px", cursor: busy ? "wait" : "pointer",
      }}
    >
      {busy ? "Opening…" : "🖨️ PDF"}
    </button>
  );
}
